module.exports = __webpack_public_path__ + "img/Arrow_Next_Dark.5343fef5.svg";